// Platform definitions organized by category
// smartInput: 'username' = auto-formats @handle or bare handle to full URL
// smartInput: 'phone' = auto-formats phone numbers to wa.me links
// urlBase: the base URL used for auto-formatting (username appended)
export const LINK_CATEGORIES = {
  social: {
    name: 'Social',
    icon: 'Users',
    color: '#E4405F',
    platforms: [
      { id: 'email', name: 'Email', icon: '\u2709\uFE0F', placeholder: 'name@example.com', smartInput: 'email', hint: 'Enter the email address people should contact' },
      { id: 'linkedin', name: 'LinkedIn', icon: 'in', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://linkedin.com/in/', hint: 'Just type your LinkedIn username' },
      { id: 'whatsapp_community', name: 'WhatsApp Community', icon: '\uD83D\uDC65', placeholder: 'Community invite link or code', smartInput: 'invite', urlBase: 'https://chat.whatsapp.com/', hint: 'Paste the community invite link or invite code' },
      { id: 'instagram', name: 'Instagram', icon: '📸', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://instagram.com/', hint: 'Just type your username' },
      { id: 'facebook', name: 'Facebook', icon: '👤', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://facebook.com/', hint: 'Just type your username' },
      { id: 'snapchat', name: 'Snapchat', icon: '👻', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://snapchat.com/add/', hint: 'Just type your username' },
      { id: 'x', name: 'X (Twitter)', icon: '𝕏', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://x.com/', hint: 'Just type your handle' },
      { id: 'threads', name: 'Threads', icon: '@', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://threads.net/@', hint: 'Just type your username' },
      { id: 'youtube', name: 'YouTube', icon: '▶️', placeholder: '@channel or full URL', smartInput: 'username', urlBase: 'https://youtube.com/@', hint: 'Just type your channel name' },
      { id: 'tiktok', name: 'TikTok', icon: '🎵', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://tiktok.com/@', hint: 'Just type your username' },
      { id: 'reddit', name: 'Reddit', icon: '🤖', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://reddit.com/u/', hint: 'Just type your username' },
      { id: 'triller', name: 'Triller', icon: '🎬', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://triller.co/@', hint: 'Just type your username' },
      { id: 'discord', name: 'Discord', icon: '💬', placeholder: 'https://discord.gg/invite' },
      { id: 'clubhouse', name: 'Clubhouse', icon: '🏠', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://clubhouse.com/@', hint: 'Just type your username' },
      { id: 'bereal', name: 'BeReal', icon: '📷', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://bereal.com/', hint: 'Just type your username' },
      { id: 'linktree', name: 'Linktree', icon: '🌳', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://linktr.ee/', hint: 'Just type your username' },
      { id: 'truthsocial', name: 'Truth Social', icon: '🇺🇸', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://truthsocial.com/@', hint: 'Just type your handle' },
      { id: 'rumble', name: 'Rumble', icon: '📺', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://rumble.com/user/', hint: 'Just type your username' },
      { id: 'mastodon', name: 'Mastodon', icon: '🐘', placeholder: 'https://mastodon.social/@username' },
      { id: 'stereo', name: 'Stereo', icon: '🎙️', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://stereo.com/', hint: 'Just type your username' },
    ]
  },
  business: {
    name: 'Business',
    icon: 'Briefcase',
    color: '#0A66C2',
    platforms: [
      { id: 'menu', name: 'Menu', icon: '📋', placeholder: 'https://yourmenu.com or upload PDF', supportsUpload: true },
      { id: 'whatsapp', name: 'WhatsApp', icon: '📱', placeholder: 'Phone number (e.g. 919876543210)', smartInput: 'phone', urlBase: 'https://wa.me/', hint: 'Enter number with country code' },
      { id: 'whatsapp_business', name: 'WhatsApp Business', icon: '💼', placeholder: 'Phone number (e.g. 919876543210)', smartInput: 'phone', urlBase: 'https://wa.me/', hint: 'Enter number with country code' },
      { id: 'telegram', name: 'Telegram', icon: '✈️', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://t.me/', hint: 'Just type your username' },
      { id: 'github', name: 'GitHub', icon: '🐙', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://github.com/', hint: 'Just type your username' },
      { id: 'minnect', name: 'Minnect', icon: '🤝', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://minnect.com/', hint: 'Just type your username' },
      { id: 'opentable', name: 'OpenTable', icon: '🍽️', placeholder: 'https://opentable.com/r/restaurant' },
      { id: 'sevenrooms', name: 'SevenRooms', icon: '🏨', placeholder: 'https://sevenrooms.com/reservations/venue' },
      { id: 'wechat', name: 'WeChat', icon: '💚', placeholder: 'WeChat ID' },
      { id: 'googlemaps', name: 'Google Maps', icon: '📍', placeholder: 'https://maps.google.com/?q=location' },
      { id: 'googlereviews', name: 'Google Reviews', icon: '⭐', placeholder: 'https://g.page/business/review' },
      { id: 'yelp', name: 'Yelp', icon: '🔴', placeholder: 'https://yelp.com/biz/business' },
      { id: 'trustpilot', name: 'Trustpilot', icon: '⭐', placeholder: 'https://trustpilot.com/review/business' },
      { id: 'bookingscom', name: 'Booking.com', icon: '🏨', placeholder: 'https://booking.com/hotel/name' },
      { id: 'hotelscom', name: 'Hotels.com', icon: '🛏️', placeholder: 'https://hotels.com/hotel/name' },
      { id: 'fiverr', name: 'Fiverr', icon: '💚', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://fiverr.com/', hint: 'Just type your username' },
      { id: 'upwork', name: 'Upwork', icon: '💼', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://upwork.com/freelancers/', hint: 'Just type your username' },
    ]
  },
  meetings: {
    name: 'Meetings & Bookings',
    icon: 'Calendar',
    color: '#4285F4',
    platforms: [
      { id: 'calendly', name: 'Calendly', icon: '📅', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://calendly.com/', hint: 'Just type your username' },
      { id: 'zoom', name: 'Zoom', icon: '📹', placeholder: 'https://zoom.us/j/meetingid' },
      { id: 'googlemeet', name: 'Google Meet', icon: '🎥', placeholder: 'https://meet.google.com/xxx-xxxx-xxx' },
      { id: 'skype', name: 'Skype', icon: '💠', placeholder: 'https://join.skype.com/invite/xxx' },
    ]
  },
  music: {
    name: 'Music',
    icon: 'Music',
    color: '#1DB954',
    platforms: [
      { id: 'spotify', name: 'Spotify', icon: '🎵', placeholder: 'https://open.spotify.com/artist/id' },
      { id: 'applemusic', name: 'Apple Music', icon: '🍎', placeholder: 'https://music.apple.com/artist/id' },
      { id: 'amazonmusic', name: 'Amazon Music', icon: '🎶', placeholder: 'https://music.amazon.com/artists/id' },
      { id: 'soundcloud', name: 'SoundCloud', icon: '☁️', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://soundcloud.com/', hint: 'Just type your username' },
      { id: 'youtubemusic', name: 'YouTube Music', icon: '🎵', placeholder: 'https://music.youtube.com/channel/id' },
      { id: 'audiomack', name: 'Audiomack', icon: '🎧', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://audiomack.com/', hint: 'Just type your username' },
      { id: 'tidal', name: 'Tidal', icon: '🌊', placeholder: 'https://tidal.com/artist/id' },
      { id: 'deezer', name: 'Deezer', icon: '🎵', placeholder: 'https://deezer.com/artist/id' },
      { id: 'pandora', name: 'Pandora', icon: '📻', placeholder: 'https://pandora.com/artist/name' },
    ]
  },
  payment: {
    name: 'Payment',
    icon: 'CreditCard',
    color: '#00D632',
    platforms: [
      { id: 'etransfer', name: 'E-Transfer', icon: '💸', placeholder: 'email@example.com' },
      { id: 'wiretransfer', name: 'Wire Transfer', icon: '🏦', placeholder: 'Bank details or instructions' },
      { id: 'paypal', name: 'PayPal', icon: '💙', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://paypal.me/', hint: 'Just type your PayPal.me username' },
      { id: 'stripe', name: 'Stripe', icon: '💳', placeholder: 'https://buy.stripe.com/xxx' },
      { id: 'applepay', name: 'Apple Pay', icon: '🍎', placeholder: 'Apple Pay instructions' },
      { id: 'venmo', name: 'Venmo', icon: '💜', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://venmo.com/', hint: 'Just type your username' },
      { id: 'cashapp', name: 'Cash App', icon: '💵', placeholder: '$cashtag or full URL', smartInput: 'username', urlBase: 'https://cash.app/$', hint: 'Just type your $cashtag' },
      { id: 'zelle', name: 'Zelle', icon: '💰', placeholder: 'email@example.com or phone' },
    ]
  },
  lifestyle: {
    name: 'Lifestyle',
    icon: 'Heart',
    color: '#E60023',
    platforms: [
      { id: 'pinterest', name: 'Pinterest', icon: '📌', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://pinterest.com/', hint: 'Just type your username' },
      { id: 'vsco', name: 'VSCO', icon: '📷', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://vsco.co/', hint: 'Just type your username' },
      { id: 'depop', name: 'Depop', icon: '🛍️', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://depop.com/', hint: 'Just type your username' },
      { id: 'opensea', name: 'OpenSea', icon: '🌊', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://opensea.io/', hint: 'Just type your username' },
      { id: 'behance', name: 'Behance', icon: '🎨', placeholder: 'username or full URL', smartInput: 'username', urlBase: 'https://behance.net/', hint: 'Just type your username' },
    ]
  }
};

export const getAllPlatforms = () => {
  const all = [];
  Object.entries(LINK_CATEGORIES).forEach(([categoryId, category]) => {
    category.platforms.forEach(platform => {
      all.push({ ...platform, category: categoryId, categoryName: category.name });
    });
  });
  return all;
};

export const getPlatformById = (platformId) => {
  for (const category of Object.values(LINK_CATEGORIES)) {
    const platform = category.platforms.find(p => p.id === platformId);
    if (platform) return platform;
  }
  return null;
};

export const getCategoryByPlatformId = (platformId) => {
  for (const [categoryId, category] of Object.entries(LINK_CATEGORIES)) {
    if (category.platforms.some(p => p.id === platformId)) {
      return { id: categoryId, ...category };
    }
  }
  return null;
};

/**
 * Smart URL formatter: converts usernames/phone numbers to full URLs
 * - If input already has http/https, returns as-is
 * - For 'username' type: strips @, builds full URL
 * - For 'phone' type: strips non-digits, builds wa.me link
 */
export const formatSocialUrl = (platformId, rawInput) => {
  if (!rawInput || !rawInput.trim()) return rawInput;
  const input = rawInput.trim();
  const platform = getPlatformById(platformId);
  if (!platform || !platform.smartInput) return input;

  // Already a full URL — don't touch
  if (/^mailto:/i.test(input)) return input;
  if (/^https?:\/\//i.test(input)) return input;

  if (platform.smartInput === 'email') {
    return `mailto:${input}`;
  }

  if (platform.smartInput === 'invite') {
    if (/^(www\.)?[a-z0-9-]+\.[a-z]{2,}\//i.test(input)) return `https://${input}`;
    return `${platform.urlBase}${input.replace(/^\/+/, '')}`;
  }

  if (platform.smartInput === 'phone') {
    // Strip everything except digits and +
    const digits = input.replace(/[^\d+]/g, '');
    if (!digits) return input;
    return `${platform.urlBase}${digits}`;
  }

  if (platform.smartInput === 'username') {
    // Strip leading @ and $ symbols
    let username = input.replace(/^[@$]+/, '');
    // If someone typed a full domain URL without protocol (has / after TLD), return with https
    if (/^(www\.)?[a-z0-9-]+\.[a-z]{2,}\//i.test(username)) return `https://${username}`;
    return `${platform.urlBase}${username}`;
  }

  return input;
};
